import { Link } from 'react-router-dom';
import { hotEvents } from '@/mocks/sports';

const eventImages: Record<string, string> = {
  'event-football-01': 'https://readdy.ai/api/search-image?query=Dramatic%20World%20Cup%20qualifying%20match%20atmosphere%20in%20massive%20stadium%2C%20national%20team%20players%20in%20action%2C%20waving%20flags%20in%20crowd%2C%20intense%20competition%20under%20floodlights%2C%20vibrant%20green%20pitch%20contrasting%20with%20colorful%20fan%20sections%2C%20wide%20angle%20sports%20photography%2C%20passionate%20international%20football%20atmosphere&width=800&height=600&seq=event-football-01&orientation=landscape',
  'event-basketball-01': 'https://readdy.ai/api/search-image?query=NBA%20Finals%20championship%20atmosphere%2C%20players%20competing%20intensely%20on%20court%20with%20championship%20trophy%20visible%20courtside%2C%20packed%20arena%20with%20dramatic%20playoff%20lighting%2C%20confetti%20and%20celebration%20vibes%2C%20professional%20basketball%20photography%20with%20epic%20scale%2C%20golden%20and%20navy%20team%20colors&width=800&height=600&seq=event-basketball-01&orientation=landscape',
  'event-esports-01': 'https://readdy.ai/api/search-image?query=Massive%20League%20of%20Legends%20World%20Championship%20opening%20ceremony%2C%20giant%20holographic%20dragon%20visual%20effects%2C%20packed%20stadium%20with%20light%20sticks%20creating%20starry%20effect%2C%20grand%20stage%20design%20with%20LED%20floor%2C%20epic%20esports%20production%20scale%2C%20dramatic%20blue%20and%20gold%20lighting%2C%20championship%20trophy%20center%20stage&width=800&height=600&seq=event-esports-01&orientation=landscape',
  'event-racing-01': 'https://readdy.ai/api/search-image?query=Formula%201%20starting%20grid%20moment%2C%20multiple%20racing%20cars%20lined%20up%20on%20track%2C%20dramatic%20tension%20before%20race%20start%2C%20iconic%20circuit%20with%20grandstands%20filled%2C%20professional%20motorsport%20photography%2C%20vibrant%20team%20colors%20against%20grey%20asphalt%2C%20heat%20haze%20rising%20from%20engines%2C%20golden%20hour%20sunlight&width=800&height=600&seq=event-racing-01&orientation=landscape',
};

export default function HotEvents() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门赛事
          </h2>
          <p className="mt-2 text-sm text-foreground-500">全球顶级赛事一网打尽，精彩不容错过</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {hotEvents.map((event) => (
            <Link
              key={event.id}
              to={`/category/${event.category}`}
              className="group relative overflow-hidden rounded-lg h-[280px] md:h-[320px] cursor-pointer"
            >
              <img
                src={eventImages[event.imageSeq]}
                alt={event.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 text-xs font-medium bg-accent-500 text-foreground-950 rounded-full mb-2">
                  {event.date}
                </span>
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1">
                  {event.name}
                </h3>
                <p className="text-sm text-white/80 line-clamp-2">
                  {event.description}
                </p>
                <div className="flex items-center gap-1 mt-2 text-white/70 text-xs">
                  <i className="ri-map-pin-line"></i>
                  <span>{event.location}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}